import { z } from 'zod';
import {
  DEFAULT_PAGE,
  DEFAULT_PAGE_SIZE,
  getParamName,
  MAX_PAGE_SIZE,
  MIN_PAGE,
  MIN_PAGE_SIZE,
} from '../../../../common';

export type TableQuerySchemaType = Record<
  string,
  z.ZodOptional<z.ZodString | z.ZodCatch<z.ZodNumber>>
>;

type GetSchemaOptionsType = {
  schemaObject: TableQuerySchemaType;
  tableId?: string;
  defaultPageSize?: number;
  minPage?: number;
  maxPageSize?: number;
  minPageSize?: number;
};

export const getSchema = ({
  schemaObject,
  tableId,
  defaultPageSize = DEFAULT_PAGE_SIZE,
  minPage = MIN_PAGE,
  maxPageSize = MAX_PAGE_SIZE,
  minPageSize = MIN_PAGE_SIZE,
}: GetSchemaOptionsType): void => {
  schemaObject[getParamName('page', tableId)] = z
    .number()
    .min(minPage)
    .catch(DEFAULT_PAGE)
    .optional();

  schemaObject[getParamName('pageSize', tableId)] = z
    .number()
    .min(minPageSize)
    .max(maxPageSize)
    .catch(defaultPageSize)
    .optional();

  schemaObject[getParamName('sort', tableId)] = z.string().optional();
  schemaObject[getParamName('search', tableId)] = z.string().optional();
};
